import { Box, FilledInput, FormControl, IconButton, InputAdornment, InputLabel, Typography } from "@material-ui/core"
import InfoOutlined from "@material-ui/icons/InfoOutlined"
import { FilledInputProps } from "@material-ui/core/FilledInput"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
import { createStyles, withStyles } from "@material-ui/styles"
import { FormikProps } from "formik"
import { Classes } from "jss"
import React from "react"
import { compose } from "react-apollo"
import ValidationMessage from "./ValidationMessage"

interface Props extends FilledInputProps {
    name: string
    label: string
    placeholder: string
    formikProps?: FormikProps<any>
    showHelperText: boolean
    classes: Classes
}

interface State {
    showPassword: boolean
}

class PasswordInput extends React.Component<Props, State> {
    static defaultProps = {
        label: "Password",
        placeholder: "Enter password",
        showHelperText: false,
    }

    state = {
        showPassword: false,
    }

    render() {
        const { name, label, placeholder, formikProps, style, classes, showHelperText, ...restProps } = this.props
        const showError = formikProps && formikProps.errors[name] && formikProps.touched[name]
        return (
            <>
                <FormControl
                    className="passwordEmailInput"
                    variant="filled"
                    fullWidth={this.props.fullWidth}
                    style={style}
                    error={Boolean(showError)}>
                    <InputLabel htmlFor={name}>{label}</InputLabel>
                    <FilledInput
                        name={name}
                        type={this.state.showPassword ? "text" : "password"}
                        placeholder={placeholder}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Toggle password visibility"
                                    style={{ padding: "4px" }}
                                    onClick={() => this.setState(state => ({ showPassword: !state.showPassword }))}>
                                    {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                        }
                        value={formikProps && formikProps.values[name]}
                        onChange={formikProps && formikProps.handleChange}
                        onBlur={formikProps && formikProps.handleBlur}
                        {...restProps}
                    />
                    {!showError && showHelperText && (
                        <Box display="flex" pl={1} pt="6px" height="26px">
                            <Box>
                                <InfoOutlined className={classes.infoIcon} />
                            </Box>
                            <Box flex="1" pl="0.4rem">
                                <Typography variant="body2" className={classes.inputDescriptionText}>
                                    Password must be at least 8 characters long.
                                </Typography>
                            </Box>
                        </Box>
                    )}
                    {showError && (
                        <Box height="26px">
                            <ValidationMessage>{formikProps.errors[name]}</ValidationMessage>
                        </Box>
                    )}
                </FormControl>
            </>
        )
    }
}

const styles = () =>
    createStyles({
        infoIcon: {
            display: "inline-block",
            opacity: 0.5,
            fontSize: "1.1rem",
        },
        inputDescriptionText: {
            color: "#444",
            fontSize: "0.75rem",
            opacity: 0.7,
            display: "inline-block",
        },
    })

export default compose(withStyles(styles))(PasswordInput)
